import React from 'react';

const SeparatorLine = () => (
  <div style={{ position: 'fixed', bottom: 0, height: 10, width: '100%', background: '#fff' }}></div>
);

export default SeparatorLine;
